import { createComponent } from '@carvana/merch-components';
import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import classNames from 'classnames';
import styled from 'styled-components';
import CtaButton from '@/vdp/CtaButton';
import { heroHeaderMaxZIndex } from '~/constants/vdp/zIndex';

export const Outer = styled.div.attrs(props => ({
  className: classNames(
    'pointer-events-none relative col-start-1 row-start-1 flex flex-col transition-opacity duration-500',
    { 'opacity-0': props.shouldHide }
  )
}))`
  z-index: ${props => (props.shouldHide ? 0 : heroHeaderMaxZIndex)};
`;

export const Inner = styled.div.attrs({
  className: 'gap-8 grid justify-between p-16 relative m:px-32 m:py-24'
})`
  background-color: transparent;
  transition: background-color 0.5s;
  grid:
    'tags tags'
    'vehicle-description price-and-button';
`;

export const TagsWrapper = styled.div`
  grid-area: tags;
`;

export const VehicleDescription = styled.div.attrs({
  className: 'gap-y-4 grid'
})`
  grid-area: vehicle-description;
`;

export const YearMakeModel = styled.p.attrs({
  className: 'font-bold text-blue-6'
})`
  font-size: 18px;
  line-height: 21px;

  @media screen and (min-width: ${legacyBreakpoints.m}px) {
    font-size: 36px;
    line-height: 42px;
  }
`;

export const TrimMileageBadge = createComponent('div', {
  className:
    'grid w-fit gap-x-8 text-blue-7 tl-body-s m:grid-flow-col m:tl-body-m'
});

export const PriceAndButton = styled.div.attrs({
  className: 'gap-x-24 grid grid-flow-col items-center'
})`
  grid-area: price-and-button;
`;

export const GetStarted = styled(CtaButton).attrs({
  className: 'pointer-events-auto'
})`
  height: 56px;
  min-width: 200px;
`;
